import * as React from 'react';
import { ButtonCallToAction, ButtonTertiary } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { TextConfigurationTranslation } from '../../constants';

import styles from './list-header.scss';

interface ListHeaderProps {
  numberOfChanges: number;
  numberOfResults: number;
  allValid: boolean;

  cancelChanges: () => void;
  saveChanges: () => void;

  updateLabel: string;
  modifiedLabel: string;
  noHitsLabel: string;

  translation: TextConfigurationTranslation;
}

export const ListHeader: React.FC<ListHeaderProps> = ({
  numberOfChanges, numberOfResults, allValid,
  cancelChanges, saveChanges,
  updateLabel, modifiedLabel, noHitsLabel, translation
}) => {

  const hasChanges = numberOfChanges > 0;

  return <>
    <StickyHeader
      className={styles.header}
      rightSideContent={<StickyHeaderButtonContainer>
        <ButtonTertiary
          id="texts_cancel_changes"
          onClick={cancelChanges}
          disabled={!hasChanges}>
          {translation.cancel_changes}
        </ButtonTertiary>
        <ButtonCallToAction
          id="texts_save_changes"
          onClick={saveChanges}
          disabled={!hasChanges || !allValid}>
          {updateLabel}
        </ButtonCallToAction>
      </StickyHeaderButtonContainer>}>
      <div className={styles.searchSummary}>
        <span id="texts_number_of_results">
          {numberOfResults === 0
            ? noHitsLabel
            : `${numberOfResults} ${translation.search_hits}`}
        </span>
        {hasChanges &&
          <span id="texts_number_of_modified">
            {numberOfChanges} {modifiedLabel}
          </span>}
      </div>
    </StickyHeader>
    {hasChanges &&
      <div className={styles.warningMessage}>
        <div className={styles.warningIcon} />
        {translation.message_unsaved_changes_warning}
      </div>}
  </>;
};
